import React, { useState, useEffect } from 'react';
import { Button, Col, Input, Row, Label, ModalBody, Form, TabPane, TabContent, Spinner, FormFeedback, FormGroup, } from 'reactstrap';

// Formik
import * as Yup from 'yup';
import { useFormik } from 'formik';
import { toast } from 'react-toastify';

//redux
import { setRequireCloseModal } from '../../../../slices/feedingSilo/reducer';
import { useSelector, useDispatch } from 'react-redux';
import { createSelector } from 'reselect';
import { addNewFeedingSilo, updateFeedingSilo } from '../../../../slices/feedingSilo/thunk';
import { getFeedingBargesList, getFuelTypeList, getPowerGenerationStatusList, getPowerGenerationTypeList } from '../../../../helpers/establishment/backend_helper';
import OSelect from '../../../../Components/OElements/OSelect';
import OInput from '../../../../Components/OElements/OInput';

const FeedingSiloForm = ({ dataFeedingSilo, isEdit, handleToggleModal, isOpen, activeTab, toggleTab, }) => {
	const dispatch = useDispatch();

	const [selectFuelType, setSelectFuelType] = useState(null);
	const [selectFeedingBarges, setSelectFeedingBarges] = useState(null);

	const selectorFeedingSilo = createSelector(
		state => state.FeedingSilo,
		result => ({
			isAdding: result.isAdding,
			isAdded: result.isAdded,
			isUpdating: result.isUpdating,
			isUpdated: result.isUpdated,
			isLoadingList: result.isLoadingList,
			requireCloseModal: result.requireCloseModal,
		})
	);
	const { isAdding, isAdded, isUpdating, isUpdated, isLoadingList, requireCloseModal, } = useSelector(selectorFeedingSilo);

	// validation
	const validation = useFormik({
		// enableReinitialize: use this flag when initial values needs to be changed
		enableReinitialize: true,
		initialValues: {
			name: (dataFeedingSilo && dataFeedingSilo.name) || '',
			capacity: (dataFeedingSilo && dataFeedingSilo.capacity) || '',
			feeding_barges_id: (dataFeedingSilo && dataFeedingSilo.feeding_barges_id) || '',
			description: (dataFeedingSilo && dataFeedingSilo.description) || '',
			stock: (dataFeedingSilo && dataFeedingSilo.stock) || '',
			material: (dataFeedingSilo && dataFeedingSilo.material) || '',
		},
		validationSchema: Yup.object({
			name: Yup.string().required('Campo requerido'),
			capacity: Yup.number()
				.required('Campo requerido')
				.min(0, 'La capacidad no puede ser negativa'),
			feeding_barges_id: Yup.string().required('Campo requerido'),
			description: Yup.string().nullable(),
			stock: Yup.number()
				.required('Campo requerido')
				.min(0, 'El stock no puede ser negativo')
				.test(
					'stock-not-exceed-capacity',
					'El stock no puede ser mayor que la capacidad',
					function (value) {
						const { capacity } = this.parent; // Obtiene el valor de `capacity`
						return value <= capacity; // Verifica que `stock` no sea mayor que `capacity`
					}
				),
			material: Yup.string().required('Campo requerido'),
		}),

		onSubmit: values => {
			const feedingSilo = {
				name: values.name,
				capacity: values.capacity,
				material: values.material,
				feeding_barges_id: values.feeding_barges_id,
				description: values.description,
				stock: values.stock,
				material: values.material,
			};


			if (isEdit) {
				feedingSilo._id = dataFeedingSilo._id;
				dispatch(updateFeedingSilo(feedingSilo));
			} else {
				dispatch(addNewFeedingSilo(feedingSilo));
			}

		},
	});

	useEffect(() => {
		if (isOpen) {
			if (requireCloseModal) {
				dispatch(setRequireCloseModal(false));
				handleToggleModal();
			}
		}
	}, [requireCloseModal]);

	return (
		<Form
			className='tablelist-form'
			onSubmit={e => {
				e.preventDefault();
				if (Object.keys(validation.errors).length != 0) { toast.error('Por favor, revisa la información ingresada. Hemos encontrado algunos detalles que necesitan corrección antes de continuar.', { autoClose: 4000 }); }
				validation.handleSubmit();
				return false;
			}}
		>
			<ModalBody className='modal-body'>
				<Row className='g-3'>
					<Col lg={3}>
						<OInput
							name='name'
							label='Nombre'
							type='text'
							validation={validation}
							isRequired={true}
							classNameLabel='form-label'
							classNameInput='form-control'
						/>
					</Col>
					<Col lg={3}>
						<OInput
							name='capacity'
							label='Capacidad'
							type='text'
							validation={validation}
							isRequired={true}
							classNameLabel='form-label'
							classNameInput='form-control'
						/>
					</Col>
					<Col lg={3}>
						<OInput
							name='stock'
							label='Saldo'
							type='text'
							validation={validation}
							isRequired={true}
							classNameLabel='form-label'
							classNameInput='form-control'
						/>
					</Col>
					<Col lg={3}>
						<OInput
							name='material'
							label='Alimento'
							type='text'
							validation={validation}
							isRequired={true}
							classNameLabel='form-label'
							classNameInput='form-control'
						/>
					</Col>
					<Col lg={3}>
						<OSelect
							key={'feeding_barges_id'}
							label='Artefacto Naval'
							id='feeding_barges_id'
							name='feeding_barges_id'
							isRequired={true}
							value={validation.values.feeding_barges_id || ''}
							onSelect={setSelectFeedingBarges}
							requestApi={() => getFeedingBargesList({})}
							validation={validation}
						/>
					</Col>
					<Col lg={9}>
						<OInput
							name='description'
							label='Descripción'
							type='textarea'
							placeholder='Ingrese una descripción'
							validation={validation}
							classNameLabel='form-label'
							classNameInput='form-control'
						/>
					</Col>
				</Row>
			</ModalBody>
			<div className='modal-footer'>
				<div className='hstack gap-2 modal-footer-add-btn'>
					<Button
						type='button'
						onClick={() => {
							handleToggleModal();
						}} className='btn-danger btn-label'>
						<i className="icon-x label-icon"></i>
						Cancelar
					</Button>
					<button
						type='submit'
						className='btn btn-label btn-primary'
						id='add-btn'
						disabled={isAdding || isUpdating}
					>
						{isAdding || isUpdating ? (<i className='label-icon'><Spinner size='sm' /></i>) : (<i className='ri-save-3-line label-icon'></i>)}
						{isEdit ? 'Editar' : 'Crear'} Silo de Alimento
					</button>
				</div>
			</div>
		</Form>
	);
};

export default FeedingSiloForm;
